import { render, staticRenderFns } from "./NewContactsComponent.vue?vue&type=template&id=db527df8"
import script from "./NewContactsComponent.vue?vue&type=script&lang=js"
export * from "./NewContactsComponent.vue?vue&type=script&lang=js"
import style0 from "./NewContactsComponent.vue?vue&type=style&index=0&id=db527df8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports